
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping&exchanges",
      function () {
        return require("private-next-pages/shipping&exchanges.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping&exchanges"])
      });
    }
  